import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {Layer} from '../layers/layer';
import {Reposition, RepositionProps} from '../reposition/reposition';
import {PopoverProps} from './popoverTypes';

/*
 * Props.
 */

export interface RepositionPopoverProps extends PopoverProps, RepositionProps {}

/*
 * Style.
 */

interface BackgroundStyleProps {
  $shouldBeVisible?: boolean;
}
const StyledBackgroundDiv = styled.div<BackgroundStyleProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(p) => (p.$shouldBeVisible ? p.theme.modalBackdrop : p.theme.alphas.transparent)};
`;

/*
 * Component.
 */

export const RepositionPopover: FC<PropsWithChildren<RepositionPopoverProps>> = ({className, ...props}) => {
  const content = (
    <>
      {props.isExclusive && (
        <StyledBackgroundDiv
          $shouldBeVisible={props.hasVisibleBackground}
          onMouseDown={(event) => {
            // Prevents the active/focused element from blurring when clicking the backdrop.
            event.preventDefault();
          }}
          onClick={props.onRequestClose}
        />
      )}
      <Reposition className={className} {...props}>
        {props.children}
      </Reposition>
    </>
  );

  if (props.isInline) {
    return content;
  }

  return <Layer {...props}>{content}</Layer>;
};
